import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/users")
      .then(({ data }) => setUsers(data))
      .catch((err) => console.warn(err))
      .finally(() => setLoading(false));
  }, []);

  const filtered = users.filter((u) =>
    !q || u.email?.toLowerCase().includes(q.toLowerCase()) || u.name?.toLowerCase().includes(q.toLowerCase())
  );

  if (loading) return <p className="font-mono-b p-6" data-testid="users-loading">LOADING USERS...</p>;

  return (
    <div data-testid="admin-users">
      <input
        data-testid="users-search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="SEARCH EMAIL OR NAME"
        className="brutal-input mb-4 w-full sm:w-96 uppercase text-sm"
      />
      <p className="font-mono-b text-xs text-black/60 mb-3">{filtered.length} user{filtered.length !== 1 ? "s" : ""}</p>
      <div className="space-y-2">
        {filtered.map((u) => (
          <div key={u.user_id} data-testid={`user-${u.user_id}`} className="bg-white border-2 border-black brutal-shadow-sm p-3 flex flex-wrap gap-4 items-center justify-between">
            <div>
              <p className="font-display text-lg">{u.name} {u.role === "admin" && <span className="sticker text-[10px]">ADMIN</span>}</p>
              <p className="font-mono-b text-xs text-black/60">{u.email} · {u.auth_provider}</p>
            </div>
            <div className="text-right">
              <p className="font-mono-b text-sm"><b>{u.order_count || 0}</b> orders · <b>₹{u.total_spent || 0}</b></p>
              <p className="font-mono-b text-xs text-black/50">Joined {new Date(u.created_at).toLocaleDateString()}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
